/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_jf_indent_tab = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tab`)
};

const es_jf_indent_tab = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tabulador`)
};

const de_jf_indent_tab = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tab`)
};

const nl_jf_indent_tab = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tab`)
};

const fr_jf_indent_tab = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tabulation`)
};

const it_jf_indent_tab = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tab`)
};

const pt_br2_jf_indent_tab = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tabulação`)
};

const pt_jf_indent_tab = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tabulação`)
};

const ja_jf_indent_tab = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タブ`)
};

const zh_jf_indent_tab = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`制表符`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const jf_indent_tab = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.jf_indent_tab(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("jf_indent_tab", locale)
	if (locale === "en") return en_jf_indent_tab(inputs)
	if (locale === "es") return es_jf_indent_tab(inputs)
	if (locale === "de") return de_jf_indent_tab(inputs)
	if (locale === "nl") return nl_jf_indent_tab(inputs)
	if (locale === "fr") return fr_jf_indent_tab(inputs)
	if (locale === "it") return it_jf_indent_tab(inputs)
	if (locale === "pt-BR") return pt_br2_jf_indent_tab(inputs)
	if (locale === "pt") return pt_jf_indent_tab(inputs)
	if (locale === "ja") return ja_jf_indent_tab(inputs)
	return zh_jf_indent_tab(inputs)
};